"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DummyLegendTools = exports.LegendTools = exports.useLegendReducer = exports.Legend = void 0;

var _react = _interopRequireDefault(require("react"));

var _Inputs = require("../Inputs");

var _deepEqual = _interopRequireDefault(require("deep-equal"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _d3Format = require("d3-format");

var _d3Array = require("d3-array");

var _d3Scale = require("d3-scale");

var _colorRanges = require("../utils/color-ranges");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ColorSteps = Object.keys(_colorRanges.ColorRanges).sort(function (a, b) {
  return +a - +b;
});

var Legend = function Legend(_ref) {
  var type = _ref.type,
      domain = _ref.domain,
      range = _ref.range,
      format = _ref.format,
      props = _objectWithoutProperties(_ref, ["type", "domain", "range", "format"]);

  var scale = _react["default"].useMemo(function () {
    return getScale(type, domain, range);
  }, [type, domain, range]);

  var Format = _react["default"].useMemo(function () {
    return getFormat(format);
  }, [format]);

  return /*#__PURE__*/_react["default"].createElement("div", null, type === "linear" ? /*#__PURE__*/_react["default"].createElement(LinearScale, _extends({
    scale: scale,
    format: Format
  }, props)) : type === "ordinal" ? /*#__PURE__*/_react["default"].createElement(OrdinalScale, _extends({
    scale: scale,
    format: Format
  }, props)) : type === "quantize" || type === "quantile" || type === "threshold" ? /*#__PURE__*/_react["default"].createElement(QuantizleScale, _extends({
    scale: scale,
    format: Format
  }, props)) : /*#__PURE__*/_react["default"].createElement("div", null, "Unknown scale type \"", type, ".\""));
};

exports.Legend = Legend;

var getScale = function getScale(type, domain, range) {
  switch (type) {
    case "linear":
      return (0, _d3Scale.scaleLinear)().domain(domain).range(range);

    case "ordinal":
      return (0, _d3Scale.scaleOrdinal)().domain(domain).range(range);

    case "quantize":
      return (0, _d3Scale.scaleQuantize)().domain((0, _d3Array.extent)(domain)).range(range);

    case "quantile":
      return (0, _d3Scale.scaleQuantile)().domain(domain).range(range);

    case "threshold":
      return (0, _d3Scale.scaleThreshold)().domain(domain).range(range);

    default:
      return null;
  }
};

var Identity = function Identity(i) {
  return i;
};

var getFormat = function getFormat(format) {
  if (!format) return Identity;

  if (typeof format === "string") {
    return (0, _d3Format.format)(format);
  }

  return format;
};

var InitialToolState = {
  size: 5,
  reverse: false,
  opened: null
};

var InitReducer = function InitReducer(_ref2) {
  var _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 5 : _ref2$size;
  return _objectSpread(_objectSpread({}, InitialToolState), {}, {
    size: Math.max(size, 3)
  });
};

var ToolReducer = function ToolReducer(state, action) {
  var type = action.type,
      payload = _objectWithoutProperties(action, ["type"]);

  switch (type) {
    case "set-size":
    case "set-reverse":
    case "set-opened":
      return _objectSpread(_objectSpread({}, state), payload);

    default:
      return state;
  }
};

var useLegendReducer = function useLegendReducer(initial) {
  return _react["default"].useReducer(ToolReducer, initial, InitReducer);
  ;
};

exports.useLegendReducer = useLegendReducer;

var LegendTools = function LegendTools(_ref3) {
  var onChange = _ref3.onChange,
      props = _objectWithoutProperties(_ref3, ["onChange"]);

  // const range = get(layer, ["legend", "range"], []);
  var _useLegendReducer = useLegendReducer(props),
      _useLegendReducer2 = _slicedToArray(_useLegendReducer, 2),
      toolState = _useLegendReducer2[0],
      dispatch = _useLegendReducer2[1]; // const updateLegend = React.useCallback(update => {
  //   MapActions.updateLegend(layer, update);
  // }, [layer, MapActions]);


  return /*#__PURE__*/_react["default"].createElement(DummyLegendTools, _extends({}, toolState, props, {
    updateLegend: onChange,
    dispatch: dispatch
  }));
};

exports.LegendTools = LegendTools;

var DummyLegendTools = function DummyLegendTools(_ref4) {
  var range = _ref4.range,
      updateLegend = _ref4.updateLegend,
      dispatch = _ref4.dispatch,
      type = _ref4.type,
      types = _ref4.types,
      size = _ref4.size,
      reverse = _ref4.reverse,
      opened = _ref4.opened;

  var colorsByType = _react["default"].useMemo(function () {
    return (0, _d3Array.groups)((0, _lodash["default"])(_colorRanges.ColorRanges, size, []), function (r) {
      return r.type;
    });
  }, [size]);

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-36"
  }, "Range Length"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1"
  }, /*#__PURE__*/_react["default"].createElement(_Inputs.Select, {
    options: ColorSteps,
    valueAccessor: function valueAccessor(v) {
      return +v;
    },
    value: size,
    onChange: function onChange(v) {
      return dispatch({
        type: "set-size",
        size: v
      });
    },
    multi: false,
    removable: false,
    searchable: false
  }))), !(types && types.length) ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-36"
  }, "Scale Type"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1"
  }, /*#__PURE__*/_react["default"].createElement(_Inputs.Select, {
    options: types,
    value: type,
    onChange: function onChange(v) {
      return updateLegend({
        type: v
      });
    },
    multi: false,
    removable: false,
    searchable: false
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center mb-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-36"
  }, "Reverse Colors"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1"
  }, /*#__PURE__*/_react["default"].createElement(_Inputs.BooleanInput, {
    value: reverse,
    onChange: function onChange(v) {
      return dispatch({
        type: "set-reverse",
        reverse: v
      });
    }
  }))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-bold border-b mb-1"
  }, "Color Range Types:"), colorsByType.map(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        type = _ref6[0],
        ranges = _ref6[1];

    return /*#__PURE__*/_react["default"].createElement(ColorType, {
      key: type,
      type: type,
      ranges: ranges,
      opened: opened,
      update: updateLegend,
      setOpen: function setOpen(opened) {
        return dispatch({
          type: "set-opened",
          opened: opened
        });
      },
      current: range,
      reverse: reverse
    });
  })));
};

exports.DummyLegendTools = DummyLegendTools;

var ColorType = function ColorType(_ref7) {
  var type = _ref7.type,
      ranges = _ref7.ranges,
      current = _ref7.current,
      opened = _ref7.opened,
      setOpen = _ref7.setOpen,
      reverse = _ref7.reverse,
      update = _ref7.update;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n      px-2 hover:border-current border-transparent border\n      cursor-pointer rounded transition\n    ",
    onClick: function onClick(e) {
      e.stopPropagation();
      setOpen(type);
    }
  }, type, /*#__PURE__*/_react["default"].createElement("div", {
    className: "pb-1",
    style: {
      display: opened === type ? "block" : "none"
    }
  }, ranges.map(function (_ref8) {
    var name = _ref8.name,
        colors = _ref8.colors;

    if (reverse) {
      colors = colors.slice().reverse();
    }

    var active = (0, _deepEqual["default"])(colors, current);
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: name,
      onClick: function onClick(e) {
        return update({
          range: colors
        });
      },
      className: "\n                p-1 border rounded-lg hover:border-current transition\n                ".concat(active ? "border-current" : "border-transparent", "\n              ")
    }, /*#__PURE__*/_react["default"].createElement(_colorRanges.ColorBar, {
      key: name,
      colors: colors,
      size: 2
    }));
  })));
};

var LinearScale = function LinearScale(_ref9) {
  var scale = _ref9.scale,
      format = _ref9.format,
      size = _ref9.size,
      _ref9$ticks = _ref9.ticks,
      ticks = _ref9$ticks === void 0 ? 5 : _ref9$ticks;
  var scaleTicks = scale.ticks(ticks);
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_colorRanges.ColorBar, {
    size: size,
    colors: scaleTicks.map(function (t) {
      return scale(t);
    })
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-sm grid grid-cols-".concat(scaleTicks.length)
  }, scaleTicks.map(function (t) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-span-1 text-right pr-1",
      key: t
    }, format(t));
  })));
};

var OrdinalScale = function OrdinalScale(_ref10) {
  var scale = _ref10.scale,
      format = _ref10.format,
      _ref10$height = _ref10.height,
      height = _ref10$height === void 0 ? 3 : _ref10$height,
      _ref10$direction = _ref10.direction,
      direction = _ref10$direction === void 0 ? "vertical" : _ref10$direction;
  var range = scale.range();
  return /*#__PURE__*/_react["default"].createElement("div", null, direction === "horizontal" ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-".concat(range.length)
  }, range.map(function (c) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-span-1 h-3 mx-2 rounded",
      key: c,
      style: {
        backgroundColor: c
      }
    });
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-".concat(range.length)
  }, scale.domain().map(function (d) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-span-1 text-center",
      key: d
    }, format(d));
  }))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex"
  }, scale.domain().reduce(function (a, c, i) {
    if (i % height === 0) {
      a.push([]);
    }

    a[a.length - 1].push(c);
    return a;
  }, []).map(function (d, i) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: i,
      className: "".concat(i > 0 ? "ml-6" : "", " flex-1")
    }, d.map(function (dd) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex items-center",
        key: dd
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "h-6 w-6 rounded mr-1 mb-1",
        style: {
          backgroundColor: scale(dd)
        }
      }), /*#__PURE__*/_react["default"].createElement("div", null, format(dd)));
    }));
  })));
};

var QuantizleScale = function QuantizleScale(_ref11) {
  var scale = _ref11.scale,
      format = _ref11.format,
      size = _ref11.size;
  var range = scale.range();
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_colorRanges.ColorBar, {
    size: size,
    colors: range
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-sm grid grid-cols-".concat(range.length)
  }, range.map(function (r) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "col-span-1 text-right pr-1",
      key: r
    }, format(scale.invertExtent(r)[1]));
  })));
};